{ partitionAndSort } = require('../../utils')
module.exports = ($scope, $routeParams, Api, adverseTerms, languages) ->
  languages = partitionAndSort(languages, 'id', 'name')
  $scope.adverseTerms = partitionAndSort(adverseTerms, 'language.name', 'id')
